
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-cream px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <Link to="/auth" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="h-4 w-4" />
          Back to sign in
        </Link>

        <h1 className="font-display text-3xl mb-2">Terms of Service</h1>
        <p className="text-sm text-muted-foreground mb-8">Effective Date: February 15, 2026</p>

        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold mb-2">1. Agreement to Terms</h2>
            <p>By accessing or using Birdie Game ("the App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">2. Description of Service</h2>
            <p>Birdie Game is a free golf birdie tracking application that allows users to record birdies, eagles, and double eagles; participate in birdie challenge games with friends; and track progress across golf courses. The App is provided as a Progressive Web App accessible through web browsers and installable on mobile devices.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">3. Eligibility</h2>
            <p>You must be at least 13 years of age to use the App. By using the App, you represent that you meet this age requirement.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">4. Account Registration and Security</h2>
            <p>To use the App, you must sign in using your Google account through Google OAuth. You are responsible for maintaining the security of your Google account credentials. You agree not to share your account access with others. You are responsible for all activity that occurs under your account and must notify us immediately if you suspect unauthorized use.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">5. Acceptable Use</h2>
            <p className="mb-2">You agree not to:</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Use the App for any unlawful purpose or in violation of any applicable laws</li>
              <li>Submit false, misleading, or fraudulent information, including fabricated golf scores</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Attempt to gain unauthorized access to the App, its servers, or any related systems</li>
              <li>Interfere with or disrupt the integrity or performance of the App</li>
              <li>Use automated systems, bots, or scrapers to access the App</li>
              <li>Impersonate any person or entity</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">6. User Content</h2>
            <p>You retain ownership of any content you submit to the App, including your golf scores and profile information. By submitting content, you grant Birdie Game a non-exclusive, royalty-free license to use, store, and display that content as necessary to provide the service. You are solely responsible for the accuracy of the scores and data you enter.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">7. Social Features and Friend Connections</h2>
            <p>The App allows you to connect with other users as friends. When you add a friend, both parties can view each other's birdie scores and game activity. You consent to this mutual sharing when you accept or send a friend request. You may remove a friend connection at any time, which will revoke mutual score visibility.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">8. Intellectual Property</h2>
            <p>The App, including its design, code, graphics, logos, and other materials, is owned by Birdie Game and is protected by applicable intellectual property laws. You may not copy, modify, distribute, or create derivative works based on the App without prior written consent.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">9. Availability and Modifications</h2>
            <p>We strive to keep the App available but do not guarantee uninterrupted or error-free service. We reserve the right to modify, suspend, or discontinue the App at any time, with or without notice. We may update these Terms from time to time. Continued use of the App after changes constitutes acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">10. Termination</h2>
            <p>We may suspend or terminate your account at our discretion if you violate these Terms. You may stop using the App at any time. Upon termination, your right to use the App ceases immediately, though provisions that by their nature should survive (such as limitations of liability) will remain in effect.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">11. Disclaimer of Warranties</h2>
            <p>The App is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the App will be error-free, secure, or available at all times. We do not warrant the accuracy or completeness of any data, including golf course information.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">12. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, Birdie Game and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the App. Our total liability for any claim arising from these Terms or your use of the App shall not exceed the amount you paid to use the App.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">13. Governing Law</h2>
            <p>These Terms are governed by and construed in accordance with the laws of the State of California, United States, without regard to conflict of law principles.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-2">14. Contact</h2>
            <p>If you have questions about these Terms, contact us at <a href="mailto:support@birdiechase.com" className="text-primary underline">support@birdiechase.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
